var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"page-title-box d-flex align-items-center justify-content-between"},[_c('b-breadcrumb',{staticClass:"m-0",attrs:{"items":_vm.items}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }